export default __webpack_public_path__ + "media/images/elephant_ui_working_sub-fff89f82637d70800685557dac89c525.png";